package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.utils.GetParashotUseCase
import com.eladfinish.bible.contest.utils.addGershaim

class BuildSearchResultSourceUseCase(
    private val getParashotUseCase: GetParashotUseCase,
) {

    operator fun invoke(
        bookName: String,
        bookIndex: Int,
        chapter: String,
        verse: String,
    ): String {
        val cleanBookName = bookName.trim()
        val cleanChapter = chapter.trim()
        val cleanVerse = verse.trim()

        val baseSource = "($cleanBookName ${cleanChapter.addGershaim()}, ${cleanVerse.addGershaim()})"

        if (bookIndex !in 0..4) {
            return baseSource
        }

        val parasha = getParashotUseCase.getParashaByBookChapterAndVerse(
            book = bookName,
            chapter = chapter,
            verse = verse,
        )

        return if (parasha.isBlank()) {
            baseSource
        } else {
            "$baseSource [פרשת $parasha]"
        }
    }
}
